// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__17qXt","noInteraction":"EventWrapper_noInteraction__3a2g6","pointerPassthrough":"EventWrapper_pointerPassthrough__1b9CZ"};